/**
 * UberButton Component
 * Button to request an Uber ride to a destination from current location
 */

import { useState } from 'react';
import { Car } from 'lucide-react';
import { requestUberToLocation } from '../services/rideshareService';

const UberButton = ({ destination, destinationName, style = {} }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleRequestUber = async () => {
    if (!destination) {
      setError('No destination address available');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await requestUberToLocation(destination, destinationName || 'Destination');
    } catch (err) {
      console.error('Error requesting Uber:', err);
      setError(err.message || 'Failed to request Uber. Please try again.');
      // Clear error after 5 seconds
      setTimeout(() => setError(null), 5000);
    } finally {
      setLoading(false);
    }
  };

  if (!destination) {
    return null;
  }

  return (
    <div style={{ position: 'relative', ...style }}>
      <button
        onClick={handleRequestUber}
        disabled={loading}
        style={{
          padding: '6px 12px',
          backgroundColor: loading ? '#6b7280' : '#000000',
          color: '#ffffff',
          border: 'none',
          borderRadius: '6px',
          fontSize: '12px',
          fontWeight: '600',
          cursor: loading ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          whiteSpace: 'nowrap',
          transition: 'background-color 0.2s',
          opacity: loading ? 0.7 : 1
        }}
        onMouseEnter={(e) => {
          if (!loading) {
            e.target.style.backgroundColor = '#1f2937';
          }
        }}
        onMouseLeave={(e) => {
          if (!loading) {
            e.target.style.backgroundColor = '#000000';
          }
        }}
      >
        {loading ? (
          <>
            <div style={{
              width: '12px',
              height: '12px',
              border: '2px solid #ffffff',
              borderTopColor: 'transparent',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }} />
            <span>Loading...</span>
          </>
        ) : (
          <>
            <Car size={14} />
            <span>Request Uber</span>
          </>
        )}
      </button>
      
      {error && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          marginTop: '4px',
          padding: '8px 10px',
          backgroundColor: '#fef2f2',
          border: '1px solid #fecaca',
          borderRadius: '6px',
          fontSize: '12px',
          color: '#991b1b',
          whiteSpace: 'normal',
          lineHeight: '1.4',
          zIndex: 1000,
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          minWidth: '200px',
          maxWidth: '300px'
        }}>
          {error}
        </div>
      )}

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default UberButton;

